<template>
  <div class="terminal-manage">
    <subfield>
      <template slot="list">
        <trees title="组织结构分组" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
      </template>
      <template slot="content">
        <enfold-ucd>
          <template slot="up">
            <div class="c-u-left">
              <img src="@/assets/images/public/public_add.png" class="icon" @click="addDevice" alt />
              <img src="@/assets/images/public/public_delete.png" class="icon" @click="handleBatchDelete" alt />
              <img
                src="@/assets/images/public/public_autoadd.png"
                class="icon"
                @click="$router.push({name: 'AcquisitionDevice'})"
                alt
                v-if="false"
              />
              <el-select v-model="equipment.type" placeholder="请选择设备" size="mini" @change="equipmentChange">
                <el-option v-for="item in equipment.list" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="c-u-right">
              <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined">
                <i slot="suffix" class="el-icon-search" @click="keyword && search(keyword)"></i>
              </el-input>
              <!-- <img src="@/assets/images/public/public_filter.png" class="icon" alt /> -->
            </div>
          </template>
          <template slot="center">
            <el-table
              ref="multipleTable"
              :data="deviceList"
              style="width: 100%"
              height="100%"
              @selection-change="selectionChange"
              v-loading="loading"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="name" label="终端名称" width="100"></el-table-column>
              <el-table-column prop="type_remark" label="设备类型" width="100"></el-table-column>
              <el-table-column prop="group_name" label="组织结构" width="100"></el-table-column>
              <el-table-column prop="remark1" label="备注信息-1"></el-table-column>
              <!-- <el-table-column prop="remark2" label="备注信息-2" width="120" ></el-table-column> -->
              <el-table-column prop="size_remark" label="分辨率"></el-table-column>
              <el-table-column label="设备状态">
                <div
                  slot-scope="scope"
                  v-if="scope.row.run_state"
                  v-html="runState(scope.row.run_state,scope.row.group_run_status)"
                ></div>
                <div v-else>
                  <span style="color: #ea1a1a;">离线</span>
                </div>
              </el-table-column>
              <el-table-column prop="sn" label="SN"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <div class="operation">
                    <img
                      class="icon"
                      src="@/assets/images/public/public_edit.png"
                      @click="handleEdit(scope.$index, scope.row)"
                      alt
                    />
                    <img
                      class="icon"
                      src="@/assets/images/public/public_delete.png"
                      @click="handleDelete(scope.$index, scope.row)"
                      alt
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template slot="down">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-ucd>
      </template>
    </subfield>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" title="删除终端">
      <div class="dd-dialog" v-if="multipleSelection.length > 0">请问是否要永久删除当前(选中)终端？</div>
      <div class="dd-dialog" v-else>当前没有选中任何需要删除的终端！</div>
    </del-dialog>
    <!-- 新增用户dialog -->
    <form-dialog
      :dialogVisible="FormDialogVisible"
      @closeDialog="FormCloseDialog"
      :title="ADDEDIT === 'ADD'?'新增设备':'编辑设备'"
      dWidth="860px"
    >
      <div class="form-item">
        <el-form :model="terminalData" :rules="rules" ref="userForm" label-width="100px">
          <!-- 设备名称 -->
          <el-form-item :label="$t('terminal.deviceName')" prop="name">
            <el-input v-model="terminalData.name"></el-input>
          </el-form-item>
          <!-- 组织结构 -->
          <el-form-item label="组织结构" prop="group_id">
            <el-select v-model="terminalData.group_id" placeholder="请选择组织结构" style="width: 100%;">
              <el-option v-for="(item, index) in groupIdLabel" :key="index" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <!-- 分辨率 -->
          <!-- 选项分辨率 -->
          <el-form-item label="分辨率" prop="size_id" v-show="terminalData.size_id !=='-1'">
            <el-select v-model="terminalData.size_id" placeholder="请选择屏幕分辨率" style="width: 100%;">
              <el-option label="自定义" value="-1"></el-option>
              <el-option
                v-for="(item, index) in configList.size"
                :key="index"
                :label="item.remark"
                :value="item.remark"
              />
            </el-select>
          </el-form-item>
          <!-- 自定义分辨率 -->
          <el-form-item label="分辨率" v-show="terminalData.size_id ==='-1'" required>
            <div class="input-label" v-if="terminalData.size_id ==='-1'">
              <el-form-item prop="w">
                <el-input-number
                  :controls="false"
                  placeholder="W"
                  :min="20"
                  v-model="terminalData.w"
                  style="width: 110px;"
                ></el-input-number>
              </el-form-item>
              <el-form-item prop="h">
                <el-input-number
                  :controls="false"
                  placeholder="H"
                  :min="20"
                  v-model="terminalData.h"
                  style="width: 110px;"
                ></el-input-number>
              </el-form-item>
              <div>
                <el-button icon="el-icon-close" circle size="mini" @click="terminalData.size_id = ''"></el-button>
              </div>
            </div>
          </el-form-item>
          <!-- 设备类型 -->
          <el-form-item label="设备类型">
            <el-select
              v-model="terminalData.type_id"
              placeholder="请选择设备类型"
              style="width: 100%;"
              :disabled="ADDEDIT === 'EDIT'"
            >
              <!-- 不显示设备Pandora v-show="item.id === '2'" -->
              <el-option v-for="(item, index) in configList.type" :key="index" :label="item.remark" :value="item.id" />
            </el-select>
          </el-form-item>
          <!-- SN -->
          <!-- SN Pandora下拉选择SN-->
          <el-form-item label="SN" prop="sn">
            <el-input :disabled="ADDEDIT === 'EDIT'" v-model="terminalData.sn" placeholder="请输入SN"></el-input>
          </el-form-item>
          <!-- SN Kommander下拉选择SN-->
          <!-- <el-form-item label="SN" v-if="terminalData.type_id !== '1' && selectServer" prop="sn">
            <el-select v-model="terminalData.sn" placeholder="请选择SN" style="width: 100%;">
              <el-option label="新增SN" value="addSN" @click.native="selectServer = false;terminalData.sn = '';"></el-option>
              <el-option
                v-for="(item, index) in kommanderServers"
                :key="index"
                :label="item.name"
                :value="item.name"
                :class="{'off-line':item.run_state === '0','on-line':item.run_state === '1'}"
                @click.native="terminalData.ks_run_state = item.run_state;terminalData.ks_id = item.ks_id"
          />-->
          <!-- 不显示不在线的设备 v-show="item.run_state === '1'" -->
          <!-- </el-select>
          </el-form-item>-->
          <!-- SN Kommander自定义SN-->
          <!-- <el-form-item label="SN" v-if="terminalData.type_id !== '1' && !selectServer" prop="sn">
            <div class="input-label">
              <el-input placeholder="SN" v-model="terminalData.sn" style="width: 226px;"></el-input>
              <div>
                <el-button icon="el-icon-close" circle size="mini" @click="selectServer = true;terminalData.sn = '';"></el-button>
              </div>
            </div>
          </el-form-item>-->
          <!-- 位置 -->
          <el-form-item label="位置" v-if="terminalData.type_id === '2'" required>
            <div class="input-label">
              <el-form-item prop="x">
                <el-input-number :controls="false" placeholder="X" v-model="terminalData.x" style="width: 127px;"></el-input-number>
              </el-form-item>
              <el-form-item prop="y">
                <el-input-number :controls="false" placeholder="Y" v-model="terminalData.y" style="width: 127px;"></el-input-number>
              </el-form-item>
            </div>
          </el-form-item>
          <!-- 密匙 -->
          <el-form-item label="密匙" v-if="terminalData.type_id === '1'">
            <el-input v-model="terminalData.secret"></el-input>
          </el-form-item>
          <!-- 备注1 -->
          <!-- <el-form-item :label="terminalData.type_id === '1'?'备注1':'备注'">
            <el-input v-model="terminalData.remark1"></el-input>
          </el-form-item>-->
          <!-- 备注2 -->
          <!-- <el-form-item label="备注2" v-if="terminalData.type_id === '1'">
            <el-input v-model="terminalData.remark2"></el-input>
          </el-form-item>-->

          <!-- 备注 -->
          <el-form-item label="备注1">
            <el-input v-model="terminalData.remark1"></el-input>
          </el-form-item>
          <el-form-item label="备注2">
            <el-input v-model="terminalData.remark2"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="map-item">
        <amap-single v-if="FormDialogVisible" :formDialog="terminalData" :dialogTitle="ADDEDIT" @amapData="amapData"></amap-single>
      </div>
      <div class="submit-device">
        <el-button @click="resetForm('userForm')" round>取 消</el-button>
        <el-button type="primary" v-loading="geocoderLoading" @click="submitForm('userForm')" round>确 定</el-button>
      </div>
    </form-dialog>
    <!-- <msg-dialog :dialogVisible="msgDialogVisible" @closeDialog="closeDialog" top="20vh" title="管理筛选"></msg-dialog> -->
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import DelDialog from '@/components/basics/DelDialog'
import FormDialog from '@/components/basics/FormDialog'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import { superDeepClone } from "@/assets/scripts/clone"
import { mPagination } from "@/components/basics/mixins";
import amapSingleDevice from "@/components/amap/amapSingleDevice";
import { runStateInfo } from "@/assets/scripts/runState"
// import MsgDialog from '@/components/basics/MsgDialog'  //筛选
export default {
  name: 'TerminalManage',
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      deviceList: [],
      multipleSelection: [],
      selectServer: true,
      configList: {},
      kommanderServers: [],
      groupIdLabel: [],
      loading: true,
      DelDialogVisible: false,
      FormDialogVisible: false,
      // msgDialogVisible: false,  //筛选
      ADDEDIT: '', // ADD新增用户或EDIT修改用户
      terminalData: {
        id: "",
        name: "device_" + new Date().getTime(),
        group_id: parseInt(this.$cookies.get("group_id")),
        type_id: 2,
        size_id: "",
        size_remark: "",
        attr_id: "1",
        sn: "",
        secret: "",
        remark1: "",
        remark2: "",
        lat: "",
        lng: "",
        kommander_server_name: "",
        ks_id: "",
        w: 1,
        h: 1,
        x: 1,
        y: 1,
        ks_run_state: "1"
      },
      terminalReset: {},
      rules: {
        // 表单验证
        name: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
        group_id: [{ required: true, message: '组织结构不能为空', trigger: 'change' }],
        sn: [{ required: true, message: 'SN不能为空', trigger: 'blur' }],
        kommander_server_name: [{ required: true, message: 'SN不能为空', trigger: 'blur' }],
        size_id: [{ required: true, message: '屏幕分辨率不能为空', trigger: 'blur' }],
        w: [{ required: true, message: '分辨率W为空', trigger: 'blur' }],
        h: [{ required: true, message: '分辨率H为空', trigger: 'blur' }],
        x: [{ required: true, message: '位置X为空', trigger: 'blur' }],
        y: [{ required: true, message: '位置Y为空', trigger: 'blur' }]
      },
      geocoderLoading: false,
      typeId: undefined,
      equipment: {
        type: "",
        list: [{
          value: '2',
          label: 'Kommander'
        },
        {
          value: '1',
          label: 'Pandora'
        }]
      }
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.getDeviceList();
    this.getConfigList();
    // this.getKommanderServers();
    this.terminalReset = superDeepClone(this.terminalData);
  },
  methods: {
    runState(rt, gt) {
      let rti = runStateInfo(rt, gt);
      return `<span style="color: ${rti.stateColor};">${rti.stateName}</span>`;
    },
    getConfigList() {
      this.$http.post("/admin/device/configList", { flag: 0 }, data => {
        this.configList = data;
        this.groupIdLabel = this.resetSelectOptions(superDeepClone(this.configList.group));
      });
    },
    resetSelectOptions(data, str = "", arr = []) {
      str += "\u00a0\u00a0";
      for (var i = 0; i < data.length; i++) {
        let obj = data[i];
        if (obj.child) {
          obj.name = str + obj.name;
          arr.push(data[i]);
          this.resetSelectOptions(obj.child, str, arr);
        }
      }
      return arr;
    },
    getKommanderServers() {
      this.$http.post("/admin/device/getKommanderServers", {}, data => {
        this.kommanderServers = data;
      });
    },
    getDeviceList(list = { group_ids: this.groupIds, limit: this.limit, page: this.page, key_word: this.keyword, type_id: this.typeId }) {
      this.loading = true;
      this.$http.post("/admin/device/list", list, data => {
        this.deviceList = data.list ? data.list : [];
        this.current = parseInt(data.count); //获取数据的总条数
        this.loading = false;
      });
    },
    // async addTerminal(terminal) {
    //   // Pandora 添加设备
    //   if (terminal.type_id === "1") {
    //     console.log("Pandora");
    //   }
    //   // Kommander 添加设备
    //   if (terminal.type_id === "2") {
    //     if (terminal.size_id === "-1") {
    //       terminal.size_id = `${terminal.w}x${terminal.h}`;
    //     } else {

    //     }
    //     terminal.sn = `${terminal.kommander_server_name}@${terminal.x}x${terminal.y}@${terminal.size_id}`;
    //     terminal.x += '';
    //     terminal.y += '';
    //   }
    //   Object.keys(terminal).forEach((key) => { terminal[key] ? "" : terminal[key] = "" });
    //   console.log(terminal);
    //   await this.$http.post("/admin/device/add", terminal, data => {
    //     console.log(data);
    //     this.getDeviceList({ group_id: this.groupId, limit: this.limit, page: 1 });
    //   });
    // },
    // async editTerminal(terminal) {
    //   // Pandora 修改设备
    //   if (terminal.type_id === "1") {
    //     console.log("Pandora");
    //   }
    //   // Kommander 修改设备
    //   if (terminal.type_id === "2") {
    //     if (terminal.size_id === "-1") {
    //       terminal.size_id = `${terminal.w}x${terminal.h}`;
    //     }
    //     terminal.sn = `${terminal.kommander_server_name}@${terminal.x}x${terminal.y}@${terminal.size_id}`;
    //     terminal.x += '';
    //     terminal.y += '';
    //   }
    //   Object.keys(terminal).forEach((key) => { terminal[key] ? "" : terminal[key] = "" });
    //   console.log(terminal);
    //   await this.$http.post("/admin/device/edit", terminal, data => {
    //     console.log(data);
    //     this.getDeviceList({ group_id: this.groupId, limit: this.limit, page: 1 });
    //   });
    // },
    async saveTerminal(terminal, type) {
      //分辨率
      if (terminal.size_id === "-1") {
        terminal.size_remark = `${terminal.w}x${terminal.h}`;
      } else {
        terminal.size_remark = terminal.size_id;
      }
      // Pandora 添加设备
      if (terminal.type_id === "1") {
        console.log("Pandora");
      }
      // Kommander 添加设备
      if (terminal.type_id === "2") {
        terminal.sn = `${terminal.kommander_server_name}@${terminal.x}x${terminal.y}@${terminal.size_remark}`;
        terminal.x += '';
        terminal.y += '';
      }
      Object.keys(terminal).forEach((key) => { terminal[key] ? "" : terminal[key] = "" });
      await this.$http.post(`/admin/device/${type}`, terminal, () => {
        this.getDeviceList({ group_ids: this.groupIds, limit: this.limit, page: 1 });
      });
    },
    getAssets(ids) {
      console.log(ids);
      this.groupIds = ids.ids;
      this.page = 1;
      this.getDeviceList();
    },
    currentChange(val) {
      this.page = val;
      this.getDeviceList();
    },
    search(keyword) {
      this.keyword = keyword;
      this.getDeviceList();
    },
    equipmentChange(val) {
      this.typeId = val;
      this.getDeviceList();
    },
    // closeDialog(isConfirm) {  //筛选
    //   if (isConfirm) {
    //     console.log(isConfirm);
    //   }
    //   this.msgDialogVisible = false;
    // },
    // filter() {
    //   this.msgDialogVisible = true;
    // },
    handleDelete(index, row) {
      console.log(index, row);
      this.multipleSelection = [];
      this.multipleSelection.push(row);
      this.DelDialogVisible = true;
    },
    handleBatchDelete() {
      this.DelDialogVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        let devices_info = [];
        this.multipleSelection.forEach((devices) => {
          const { id, sn, name, type_id } = devices;
          devices_info.push({ id, sn, name, type_id });
        });
        this.$http.post("/admin/device/del", { device_select_mode: "multiple", devices_info: encodeURIComponent(JSON.stringify(devices_info)) }, () => {
          this.getDeviceList({ group_ids: this.groupIds, limit: this.limit, page: 1 });
        });
      }
      this.DelDialogVisible = false;
    },
    handleEdit(index, row) {
      // console.log(index, row);
      this.ADDEDIT = "EDIT";
      this.$http.post("/admin/device/detail", { id: row.id }, (data) => {
        this.terminalData = data;
        this.terminalData.size_id = this.terminalData.size_remark;
        this.$set(this.terminalData, 'kommander_server_name', this.terminalData.sn.split("@")[0])
        this.FormDialogVisible = true;
      });

    },
    addDevice() {
      this.ADDEDIT = "ADD";
      // 每次打开添加设备都会随机分配设备名称
      // this.name = "device_" + new Date().getTime();
      this.FormDialogVisible = true;
    },
    FormCloseDialog() {
      this.selectServer = true;
      this.terminalData = superDeepClone(this.terminalReset);
      this.FormDialogVisible = false;
    },
    submitForm(userForm) {
      this.$refs[userForm].validate((valid) => {
        if (valid && (this.ADDEDIT === "ADD")) {
          // 新增用户
          this.saveTerminal(this.terminalData, 'add');
          this.FormDialogVisible = false;
        } else if (valid && (this.ADDEDIT === "EDIT")) {
          // 编辑用户
          this.saveTerminal(this.terminalData, 'edit');
          this.FormDialogVisible = false;
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(userForm) {
      this.FormDialogVisible = false;
      this.$refs[userForm].resetFields();
    },
    amapData(value) {
      if (value.citycode) {
        this.terminalData.lng = value.position[0];
        this.terminalData.lat = value.position[1];
        this.terminalData.citycode = value.citycode;
        this.terminalData.adcode = value.adcode;
        this.terminalData.formattedAddress = value.address;
        this.geocoderLoading = false;
      } else {
        this.geocoderLoading = true;
      }
    },
  },
  components: {
    subfield,
    trees,
    pagination,
    DelDialog,
    FormDialog,
    // MsgDialog, //筛选
    EnfoldUcd,
    "amap-single": amapSingleDevice
  }
}
</script>

<style lang="scss" scoped>
.terminal-manage {
  width: 100%;
  height: 100%;
  .c-u-left {
    display: flex;
    .el-select {
      width: 140px;
    }
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }
    /deep/ .el-input__suffix {
      line-height: 30px;
      color: #2fb3ff;
      font-size: 16px;
      top: -2px;
      right: 10px;
    }
  }
  .c-u-right {
    display: flex;
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }
    /deep/ .el-input__suffix {
      line-height: 30px;
      color: #2fb3ff;
      font-size: 16px;
      right: 10px;
    }
    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon {
      margin: 0px;
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }
  .dd-dialog {
    width: 100%;
    font-size: 16px;
    padding: 40px 0px;
    text-align: center;
  }
  .msg-dialog {
    /deep/ .md-content {
      display: flex;
      flex-wrap: wrap;
      // height: calc(100vh - 200px);
      .form-item {
        width: 360px;
        max-height: calc(100vh - 320px);
        overflow-x: scroll;
        padding-right: 32px;
        .el-form {
          /deep/ .el-input__inner {
            border-radius: 20px;
          }
          .el-form-item__content {
            .el-button {
              margin-left: 16px;
            }
          }
          .el-form-item:last-child {
            margin-bottom: 0px;
          }
        }
        .input-label {
          display: flex;
          justify-content: space-between;
          .el-button {
            margin-left: 0px !important;
          }
        }
      }
      .map-item {
        width: 436px;
        box-sizing: border-box;
      }
      .submit-device {
        width: 100%;
        // height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 22px;
      }
    }
  }
}
</style>
<style>
.off-line {
  color: red !important;
}
</style>
